module.exports = __webpack_public_path__ + "img/maim_yes.1506399d.png";